import { render, staticRenderFns } from "./Report-4.vue?vue&type=template&id=47c80619&scoped=true"
import script from "./Report-4.vue?vue&type=script&lang=js"
export * from "./Report-4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c80619",
  null
  
)

export default component.exports